module.exports = __webpack_public_path__ + "static/media/price4.06116e7e.png";